import { get } from "lodash";
import authActions from "../actions/auth";

const initialState = {
  user: null,
  isFetched: false,
  isAuthenticated: false,
  token: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case authActions.SetToken.REQUEST:
      return {
        ...state,
        token: action.payload,
      };

    case authActions.GetMe.SUCCESS:
      const organizations = get(action.payload, "branches", []);
      const selected_organization = get(action.payload, "organization", null);

      const hasMain = organizations.find((o) => o.is_main === 1);
      const isMain = get(selected_organization, "is_main") === 1;

      return {
        ...state,
        isFetched: true,
        isAuthenticated: true,
        user: action.payload,
        organizations: organizations,
        selected_organization: selected_organization,
        system_currency_codes: get(
          selected_organization,
          "setting.system_currency_codes",
        ),
        default_currency_code: get(
          selected_organization,
          "setting.default_currency_code",
        ),
        has_main_organization: !!hasMain,
        is_main_organization: isMain,
        is_filial_organization: get(selected_organization, "is_main") === 2,
      };
    case authActions.Logout.REQUEST:
    case authActions.Logout.FAILURE:
    case authActions.GetMe.FAILURE:
      return {
        ...state,
        isFetched: true,
        isAuthenticated: false,
        token: "",
        user: null,
      };

    default:
      return state;
  }
};
